import "swiper/swiper-bundle.css";

import { FreeMode, Mousewheel, Pagination } from "swiper/modules";

import Swiper from "swiper";
import Tabby from "tabbyjs";

document.addEventListener("DOMContentLoaded", () => {
	const tabs = document.querySelector("[data-tabs]");
	if (tabs) {
		new Tabby("[data-tabs]");
	}
});

Array.from(document.querySelectorAll(".swiper.find-us-gallery")).map(
	(gallery) => {
		const swiper = new Swiper(gallery, {
			modules: [Pagination],
			slidesPerView: 1,
			spaceBetween: 16,
			freeMode: true,
			mousewheel: false,
			grabCursor: false,
			autoHeight: true,
			pagination: {
				el: gallery.querySelector(".swiper-pagination"),
				type: "progressbar",
			},
		});
	}
);
